import {
  workMobileStatusProxy,
  workPsnlworkProxy,
  workApprovalProxy,
} from './index';
// proxy/work/mobile/status/
// proxy/work/psnlwork/
// proxy/work/approval/

/* [ 현황 - work ] */
// 근무기간정보 목록조회
function getWorkTermInfoList(params) {
  return workMobileStatusProxy.get('time/1.0/work-term/info/list', { params });
}

// 근무주기조회
function getWorkCycle(params) {
  return workPsnlworkProxy.get('calendar/1.0/week/term', { params });
}

// 근무현황 시간정보조회
function getWorkStaTimeInfo(params) {
  return workPsnlworkProxy.get('calendar/1.0/info', { params });
}

// 개인근무현황 주단위조회
function getWorkStaWeekList(params) {
  return workMobileStatusProxy.get('time/1.0/week/list', { params });
}

// 연장근무보상시간 정보조회 (=잔여휴가조회)
function getWorkOverTimeInfo(params) {
  return workApprovalProxy.get('reward/app/1.0/info', { params });
}

// 연장근무보상내역조회
function getWorkOverRewardList(params) {
  return workApprovalProxy.get('reward/app/1.0/modal/list', { params });
}

// 부서원근태현황 권한별 목록조회
function getOrgWorkStaByAuthList(params) {
  return workMobileStatusProxy.get('org/1.0/list', { params });
}

// 휴가현황 정보조회 (=잔여휴가일조회)
function getHolidayStaInfo(params) {
  return workMobileStatusProxy.get('holiday/1.0/info', { params });
}

// 휴가현황 목록조회
function getHolidayStaList(params) {
  return workMobileStatusProxy.get('holiday/1.0/list', { params });
}

export {
  getWorkTermInfoList,
  getWorkCycle,
  getWorkStaTimeInfo,
  getWorkStaWeekList,
  getWorkOverTimeInfo,
  getWorkOverRewardList,
  getOrgWorkStaByAuthList,
  getHolidayStaInfo,
  getHolidayStaList,
};
